import React, { useState, useContext } from 'react';
import useFormProcessor from '../../hooks/useFormProcessor';

import { getCookie } from '../../utils/cookie';

import { ProjectsContext } from '../../providers/projects-context.provider';
import { TeamsContext } from '../../providers/teams-context.provider';

import { updateTeam, deleteTeam } from '../../services/teams.service';
import { getEmptyInputsErrorsObject } from '../../utils/errors/teams';
import { validateTitle } from '../../utils/validations/teams';

import ErrorMessageContainer from '../form-input-error-message';
import FormInput from '../form-input';
import NavLink from '../nav-link';
import CardFormContainer from '../card-form-container';

const initialIsEditClicked = false;
const initialError = { Name: '', Key: '' };

const TeamCard = ({ initialData }) => {
	const {
		data,
		errors,
		setErrors,
		setData,
		handleChange,
		handleOnBlur,
		handleSubmit
	} = useFormProcessor(initialError, {
		...initialData
	});
	const { saveUpdatedTeams } = useContext(TeamsContext);
	const { currentProject } = useContext(ProjectsContext);

	const [ isEditClicked, setIsEditClicked ] = useState(initialIsEditClicked);

	const handleUpdate = async () => {
		const { Title } = data;
		const token = getCookie('x-auth-token');

		try {
			await updateTeam(currentProject.Id, token, initialData.Id, { Title, ImageUrl: '' });
			saveUpdatedTeams();
		} catch (error) {
			console.log(error);
		}
	};

	const handleDeleteClick = async () => {
		const token = getCookie('x-auth-token');

		try {
			await deleteTeam(currentProject.Id, token, initialData.Id);
			saveUpdatedTeams();
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<CardFormContainer
			showEdit={currentProject.IsCreator}
			isEditClicked={isEditClicked}
			setIsEditClicked={setIsEditClicked}
			initialData={initialData}
			initialError={initialError}
			setData={setData}
			setErrors={setErrors}
			handleDeleteClick={handleDeleteClick}
			handleSubmit={(e) => handleSubmit(e, getEmptyInputsErrorsObject({ Title: data.Title }), handleUpdate)}
		>
			<div className="pt-1">
				{!isEditClicked ? (
					<NavLink
						to={`/user/dashboard/${currentProject.Id}/teams/${data.Id}`}
						hoverColor="green-400"
						otherClasses="cursor-pointer text-xl text-gray-900 leading-tight"
					>
						{data.Title}
					</NavLink>
				) : (
					<div>
						<FormInput
							autoFocus
							className="focus:outline-none p-1 pl-2 text-xl text-black leading-tight"
							type="text"
							name="Title"
							value={data.Title}
							onChange={handleChange}
							handleOnBlur={(event) => handleOnBlur(event, validateTitle, { Title: data.Title })}
							placeholder="Team Title"
						/>
						{errors.Title ? <ErrorMessageContainer>{errors.Title}</ErrorMessageContainer> : null}
					</div>
				)}
			</div>
		</CardFormContainer>
	);
};

export default TeamCard;
